"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdNotice = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _reactRouterRedux = require("react-router-redux");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdNotice = exports.AdNotice = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AdNotice, _Component);

  function AdNotice() {
    (0, _classCallCheck3.default)(this, AdNotice);
    return (0, _possibleConstructorReturn3.default)(this, (AdNotice.__proto__ || (0, _getPrototypeOf2.default)(AdNotice)).apply(this, arguments));
  }

  (0, _createClass3.default)(AdNotice, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Ilmoittaminen palvelussa" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h3" },
              "Ilmoittaminen palvelussa"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Asiakkaiden sopiessa maa-ainesten toimituksien vastaanottamisesta on hyv\xE4 huomioida seuraavat asiat:"
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "1."
              ),
              " Maa-aineksien laadun tulee olla sit\xE4 mit\xE4 on sovittu."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "2."
              ),
              " Kuljetuskaluston koon tulee olla oikea suhteessa maa-aineksen m\xE4\xE4r\xE4\xE4n."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "3."
              ),
              " Vastaanottopaikan tieverkon tulee olla riitt\xE4v\xE4n kest\xE4v\xE4."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "4."
              ),
              " Kuljetusreitin ja j\xE4tt\xF6paikan olosuhteet kuten puut, oksat ja matalat ilmajohdot."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "5."
              ),
              " M\xE4\xE4rist\xE4 riippuen vastaanottopaikassa tulee olal kone purkua varten. Yleisesti ottaen koneen ollessa paikalla toimitukset onnistuvat parhaiten."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "6."
              ),
              " Toimitusaikojen tulee olla sit\xE4 mist\xE4 on sovittu."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "N\xE4in v\xE4ltyt\xE4\xE4n ep\xE4selvyyksilt\xE4, kun sek\xE4 tilaaja ett\xE4 toimittaja ovat yhteisymm\xE4rryksess\xE4 ja toimivat sovitun mukaisesti."
              )
            ),
            _react2.default.createElement(_Button2.default, {
              text: "OK",
              additionalClasses: "button-set-width",
              onClick: this.handleClick.bind(this)
            })
          )
        )
      );
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.props.pushRoute("/jata-ilmoitus");
    }
  }]);
  return AdNotice;
}(_react.Component), _class.propTypes = {
  pushRoute: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {};
}, {
  pushRoute: _reactRouterRedux.push
})(AdNotice);


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Ads/AdNotice.js
 ** module id = 1203
 ** module chunks = 0
 **/